if (!customElements.get('rc-brand-directory')) {
  customElements.define('rc-brand-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const input = this.querySelector('[data-rc-brand-search]');
      const cards = [...this.querySelectorAll('[data-rc-brand]')];
      const groups = [...this.querySelectorAll('[data-rc-brand-group]')];
      const buttons = [...this.querySelectorAll('[data-rc-brand-letter]')];
      const count = this.querySelector('[data-rc-brand-count]');
      const clear = this.querySelector('[data-rc-brand-clear]');
      const empty = this.querySelector('[data-rc-brand-empty]');
      let selected = 'all';
      const normalize = value => value.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase('sv').replace(/[\s\-_'’]+/g, ' ').trim();
      const update = () => {
        const query = normalize(input.value);
        let visible = 0;
        cards.forEach(card => {
          const matches = normalize(card.dataset.rcBrand).includes(query);
          const group = card.closest('[data-rc-brand-group]').dataset.rcBrandGroup;
          card.hidden = !matches || (selected !== 'all' && group !== selected);
          if (!card.hidden) visible++;
        });
        groups.forEach(group => group.hidden = ![...group.querySelectorAll('[data-rc-brand]')].some(card => !card.hidden));
        buttons.forEach(button => {
          const letter = button.dataset.rcBrandLetter;
          button.setAttribute('aria-pressed', String(letter === selected));
          button.disabled = letter !== 'all' && !cards.some(card => card.closest('[data-rc-brand-group]').dataset.rcBrandGroup === letter && normalize(card.dataset.rcBrand).includes(query));
        });
        count.textContent = count.dataset.countTemplate.replace('__RC_BRAND_COUNT__', String(visible));
        clear.hidden = input.value.length === 0;
        empty.hidden = visible !== 0;
      };
      const reset = () => { input.value = ''; selected = 'all'; update(); input.focus(); };
      input.addEventListener('input', () => { selected = 'all'; update(); });
      buttons.forEach(button => button.addEventListener('click', () => { selected = button.dataset.rcBrandLetter; update(); }));
      clear.addEventListener('click', reset);
      this.querySelector('[data-rc-brand-reset]').addEventListener('click', reset);
      this.querySelector('[data-rc-brand-tools]').hidden = false;
      update();
    }
  });
}
